export class AddressModel {
    public address: string;
    public city: string;
    public city_id: string;
    public complement: string;
    public country: string;
    public created_at: string;
    public deleted_at: string;
    public id: number;
    public neighborhood: string;
    public number: string;
    public state: string;
    public zip_code: string;
    public extra_fields: object = {};
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/shared/models/address.model.ts